var docSiteUrl = 'https://fluentsite.z22.web.core.windows.net';
var constants = {
  docSiteUrl: docSiteUrl,
  quickStartUrl: docSiteUrl + "/quick-start",
  repoURL: 'https://github.com/microsoft/fluentui',
  typeOrder: ['component', 'behavior']
};
export default constants;
//# sourceMappingURL=constants.js.map
